// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sM5iD","clinicsSelect":"styles_clinicsSelect__2J6wq"};